// Styles for BrandRibbon go here.
import { baseVariables, toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';

export const StyledBrandRibbon = styled.div<{ isLogoFlagEnabled: boolean }>`
  [data-component-name='m-ui-library-LogoContainer'] {
    width: unset;
    padding-left: ${props => (props.isLogoFlagEnabled === true ? `${toRem(18)}` : `unset`)};
    padding-right: ${props => (props.isLogoFlagEnabled === true ? `${toRem(18)}` : `unset`)};
    padding-bottom: ${toRem(16)};
    @media only ${baseVariables.mediaQuery.md} {
      padding-left: ${props => (props.isLogoFlagEnabled === true ? `${toRem(8)}` : `unset`)};
      padding-right: ${props => (props.isLogoFlagEnabled === true ? `${toRem(8)}` : `unset`)};
      padding-bottom: 0;
    }
    @media only ${baseVariables.mediaQuery.lg} {
      padding-left: unset;
      padding-right: unset;
      padding-bottom: 0;
    }
  }

  [dir='rtl'] & {
    @media only ${baseVariables.mediaQuery.xl} {
      padding-right: ${toRem(130)} !important;
      padding-left: 0 !important;
    }
  }

  .row {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  .brand-ribbon-container {
    width: 100%;
    @media only ${baseVariables.mediaQuery.xl} {
      padding-left: 0 !important;
      max-width: ${toRem(1140)};
      margin: 0 auto !important;
    }

    [dir='rtl'] & {
      @media only ${baseVariables.mediaQuery.xl} {
        padding-right: 0 !important;
      }
    }
  }

  .brand-container {
    .icon-class {
      display: inline-block;
      padding-right: ${toRem(12)};
      padding-left: ${toRem(12)};
    }
    .icon-class::before {
      line-height: ${toRem(36)};
      font-weight: 500;
    }
    .logo-link {
      display: inline-block;
      @media only ${baseVariables.mediaQuery.lg} {
        margin: auto;
      }
    }
    .first-logo {
      @media only ${baseVariables.mediaQuery.lg} {
        margin-left: 0;
      }
    }
    justify-content: center;
    @media only ${baseVariables.mediaQuery.md} {
      justify-content: space-around;
    }
    @media only ${baseVariables.mediaQuery.lg} {
      justify-content: space-around;
    }
  }
  .brand-logo-EB::before {
    font-size: ${toRem(16)} !important;
  }
  .brand-logo-WH::before {
    font-size: ${toRem(16)} !important;
  }
  .brand-logo-XR::before {
    font-size: ${toRem(34)} !important;
  }
  .brand-logo-LC::before {
    font-size: ${toRem(30)} !important;
  }
  .brand-logo-RZ::before {
    font-size: ${toRem(33)} !important;
  }
  .brand-logo-JW::before {
    font-size: ${toRem(30)} !important;
  }

  .main-logo {
    display: inline-block;
    padding-bottom: ${toRem(16)};
    @media only ${baseVariables.mediaQuery.md} {
      padding-right: ${toRem(20)};
      padding-bottom: 0;
      padding-top: ${toRem(6)};
    }
  }
  .main-logo::before {
    font-size: ${toRem(21)};
    line-height: normal;
    font-weight: 500;
  }

  .line-seperator {
    display: none;
    background-color: ${baseVariables.color['neutral40']};
    @media only ${baseVariables.mediaQuery.md} {
      display: inline-block;
      width: ${toRem(1)};
      height: ${toRem(24)};
    }
    @media only ${baseVariables.mediaQuery.md} {
      margin: auto;
    }
  }

  .main-logo-container {
    [data-component-name='m-ui-library-LogoContainer'] {
      padding: 0;
    }
    .logo-link,
    .background-aware-logo {
      border-bottom: solid ${toRem(1)} ${baseVariables.color['neutral40']};
      @media only ${baseVariables.mediaQuery.md} {
        display: flex;
        border-bottom: none;
      }
    }
    @media only ${baseVariables.mediaQuery.md} {
      align-items: center;
    }
  }

  .dark-color-theme {
    .logo-link {
      color: ${baseVariables.color['merch50']};
      &:hover {
        color: ${baseVariables.color['neutral30']};
      }
    }
    [data-component-name='m-ui-library-LogoContainer'] {
    .background-aware-logo svg path,
    .standard .background-aware-logo svg path,
    .inverse .background-aware-logo svg path,
    .alternate .background-aware-logo svg path,
    [class^='color-scheme'] .background-aware-logo svg path {
      fill: ${baseVariables.color['merch50']} !important;
    }
    &:hover 
      .background-aware-logo svg path,
      .standard .background-aware-logo svg path,
      .inverse .background-aware-logo svg path,
      .alternate .background-aware-logo svg path,
      [class^='color-scheme'] .background-aware-logo svg path {
        fill: ${baseVariables.color['neutral30']} !important;
      }
    }
  }

  .light-color-theme {
    .logo-link {
      color: ${baseVariables.color['neutral40']};
      &:hover {
        color: ${baseVariables.color['base10']};
      }
    }

    [data-component-name='m-ui-library-LogoContainer'] {
    .background-aware-logo svg path,
    .standard .background-aware-logo svg path,
    .inverse .background-aware-logo svg path,
    .alternate .background-aware-logo svg path,
    [class^='color-scheme'] .background-aware-logo svg path {
      fill: ${baseVariables.color['neutral40']} !important;
    }
    &:hover 
      .background-aware-logo svg path,
      .standard .background-aware-logo svg path,
      .inverse .background-aware-logo svg path,
      .alternate .background-aware-logo svg path,
      [class^='color-scheme'] .background-aware-logo svg path {
        fill: ${baseVariables.color['base10']} !important;
      }
    }
    }
  }
`;
